import React, { FunctionComponent } from "react";

const Separator: FunctionComponent = () => {
  return (
    <div className="TopFooter__Separator w-full border-b my-6 lg:my-0 lg:border-b-0 lg:w-auto lg:h-16 lg:border-l border-white"></div>
  );
};
export default Separator;
